module.exports = __webpack_public_path__ + "static/img/37.f50aa73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/37.png
// module id = HUaw
// module chunks = 0